import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import buddhistEra from 'dayjs/plugin/buddhistEra'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import relativeTime from 'dayjs/plugin/relativeTime'
import updateLocale from 'dayjs/plugin/updateLocale'
import 'dayjs/locale/th'
import 'dayjs/locale/en'
import 'dayjs/locale/zh-cn'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(buddhistEra)
dayjs.extend(localizedFormat)
dayjs.extend(relativeTime)
dayjs.extend(updateLocale)

const dayjstimethai = (data) => {
  return dayjs(data).tz('Pacific/Kiritimati').locale('th').format('LT')
}
const dayjsdatethai = (data) => {
  return dayjs(data).add(543, 'year').tz('Pacific/Kiritimati').locale('th').format('ll')
}
const dayjsdateen = (data) => {
  return dayjs(data).tz('Pacific/Kiritimati').locale('en').format('ll')
}
const dayjsdatecn = (data) => {
  return dayjs(data).tz('Pacific/Kiritimati').locale('zh-cn').format('ll')
}
const dayjstimethaiformnow = (data) => {
  return dayjs(dayjs(data).add(7, 'hour').tz('Pacific/Kiritimati').format().replace(/T/g, ' '), 'YYYY-MM-DD HH:mm:ss').locale('th').fromNow()
}
const dayjstimethaiformnowcn = (data) => {
  return dayjs(dayjs(data).add(7, 'hour').tz('Pacific/Kiritimati').format().replace(/T/g, ' '), 'YYYY-MM-DD HH:mm:ss').locale('zh-cn').fromNow()
}
const dayjstimethaiformnowen = (data) => {
  return dayjs(dayjs(data).add(7, 'hour').tz('Pacific/Kiritimati').format().replace(/T/g, ' '), 'YYYY-MM-DD HH:mm:ss').fromNow()
}
const dayjstimestamp = () => {
  return dayjs().tz('America/Danmarkshavn').format().replace(/T/g, ' ').replace('Z', '')
}
const dayjsdatetimethai = (data) => {
  return dayjs(data).tz('Asia/Bangkok').locale('th').format('llll').split('เวลา')[0]
}
const dayjsCreateDate = () => {
  return dayjs().tz('Asia/Bangkok').locale('th').format().replace(/T/g, ' ').replace('Z', '')
}

const ExpiredDataOnechatToken = () => {
  var today = new Date()
  var dd = String(today.getDate()).padStart(2, '0')
  var hour = String(today.getHours() + 1).padStart(2, '0')
  var minute = String(today.getMinutes()).padStart(2, '0')
  var seconds = String(today.getSeconds()).padStart(2, '0')
  var milsec = today.getMilliseconds()
  var mm = String(today.getMonth() + 1).padStart(2, '0')
  var yyyy = today.getFullYear()
  // เช็คเวลาช่วงเที่ยงคืน ให้บวกค่าวันไปด้วย
  if (hour === '24') {
    hour = '00'
    dd = String(today.getDate() + 1).padStart(2, '0')
    var date_of_month = new Date(yyyy, mm + 1, 0).getDate()
    // เช็ควันที่บวกว่าเป็นวันสุดท้ายของเดือน?
    if (parseInt(dd) === date_of_month) {
      // ถ้าเป็นวันสุดท้ายของเดือนในเซตวันเป็นวันที่ 1
      dd = '1'
      // เช็คเดือนว่าเป็นเดือนสุดท้ายของปี?
      if (mm === '12') {
        // ถ้าเป็นเดือนสุดท้ายในเซตเป็นเดือน 1แล้วก็บวกปีเพิ่ม
        mm = '1'
        yyyy = today.getFullYear() + 1
      } else {
        // ไม่ใช่เดือนสุดท้ายก็บวกเดือนเพิ่มมา 1 เดือน (+2 เพราะว่าเดือนมันเริ่มที่ 0 getMonth ล่่าสุดมาแล้ว คือ +1 แล้วบวกไปอีก 1 เลยเป็น +2)
        mm = String(today.getMonth() + 2).padStart(2, '0')
        // console.log(mm)
      }
    }
  }
  today = yyyy + '-' + mm + '-' + dd + 'T' + hour + ':' + minute + ':' + seconds + '.' + milsec + 'Z'
  // console.log(today)
  return Date.parse(today)
}

export default {
  dayjstimethai,
  dayjsdatethai,
  dayjstimethaiformnow,
  dayjstimethaiformnowcn,
  dayjstimethaiformnowen,
  dayjstimestamp,
  dayjsdatetimethai,
  dayjsdateen,
  dayjsdatecn,
  dayjsCreateDate,
  ExpiredDataOnechatToken
}
